import { render, staticRenderFns } from "./speltcontls.vue?vue&type=template&id=1f2e8620&scoped=true&"
import script from "./speltcontls.vue?vue&type=script&lang=js&"
export * from "./speltcontls.vue?vue&type=script&lang=js&"
import style0 from "./speltcontls.vue?vue&type=style&index=0&id=1f2e8620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e8620",
  null
  
)

export default component.exports